import { POIShapeFormModel } from './POIShapeForm';
var POILocationFormModel = /** @class */ (function () {
    function POILocationFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, shapeType = _a.shapeType, shape = _a.shape;
        this.shapeType = shapeType;
        this.shape = POIShapeFormModel.assign(shape);
        this.newItem = {
            id: null,
            new: false,
        };
    }
    POILocationFormModel.assign = function (data) {
        return new POILocationFormModel(data);
    };
    return POILocationFormModel;
}());
export { POILocationFormModel };
